import React from 'react'

export const Alpaka_Spaziergang = () => {
    return (
        <div className="randBox" id="spaziergang">
  <h2>Alpaka-Spaziergang</h2>
  <p>
    Erlebt eine kleine, feine Runde rund um unseren Hof und hinein in die idyllischen Niddaauen. <br />
    Dabei könnt ihr die Natur genießen, unsere Alpakas auf euch wirken lassen und einfach mal die Seele baumeln lassen.
  </p>
  <p>
    Etwa eine Stunde lang spazieren wir gemütlich rund um den Waldhof – ganz entspannt und im Tempo der Tiere. <br />
    Bitte plant ausreichend Zeit ein – manchmal dauert so ein Spaziergang einfach länger.
  </p>
  <p>
    Nach dem Spaziergang dürfen die Alpakas gefüttert, abgehalftert und auf ihre Weide zurückgebracht werden.
  </p>
  <p>
    Anschließend lassen wir den Ausflug bei einer Tasse Kaffee oder Tee gemütlich ausklingen. <br />
    Wenn das Wetter mitspielt, sitzen wir draußen auf der Weide und erzählen euch noch einiges über unsere ruhigen und sanftmütigen Tiere.
  </p>
  <ul>
      <li><strong>Hinweise:</strong>
          <ul>
              <li>Kinder unter 14 Jahren benötigen eine erwachsene Begleitperson</li>
          </ul>
      </li>
      <li><strong>Preise:</strong>
          <ul>
          <li>Erwachsene: <strong>20,00€</strong> </li>
          <li>Kinder unter 14 Jahren: <strong>15,00€</strong> </li>
          <li>Kinder unter 6 Jahren: <strong>10,00€</strong> </li>
          </ul>
      </li>
    </ul>

        </div>
    )
}